/* 出房管理 */
import fetch,{postFrom} from '../utils/fetch';

// 下拉框数据
export function getSelectedData() {
  return fetch({
      method: 'GET',
      url: 'outHouse/condition'
  })
}

// 出房列表
export function getOutHouseList(params) {
  return fetch({
      method: 'GET',
      url: 'outHouse/outHouselist',
      params
  })
}

// 房源详情
export function getHouseDetail(stockFid) {
  return fetch({
      method: 'GET',
      url: 'outHouse/houseDetail',
      params:{
        stockFid
      }
  })
}

// 销控台总览数据
export function marketingCtrlOverView(projectFid) {
  return fetch({
    method: 'GET',
    url: 'outHouse/marketingCtrlOverView',
    params:{
      projectFid
    }
  })
}

export function marketingCtrlVacant(houseBuildingFid) {
  return fetch({
    method: 'GET',
    url: 'outHouse/marketingCtrlVacant',
    params:{
      houseBuildingFid
    }
  })
}

// 根据项目和楼栋查询所有房间
export function canSelectStock(params) {
  return fetch({
    method: 'GET',
    url: 'outHouse/stockList',
    params
  })
}
